import { useEffect, useState } from 'react';
import type { StatefulRoom } from '../../../lib/sendbird-calls/SbCallsContext';
import {
  Wrapper,
  ParticipantView,
  ParticipantInfo,
  ParticipantMutedIcon,
  ParticipantsRow,
} from './styles';
import { Video } from './Video';

type Props = { room: StatefulRoom; showParticipants: boolean };

const MediaContent = ({ room, showParticipants }: Props) => {
  const { participants, localParticipant, remoteParticipants } = room;

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
  }, []);

  if (!remoteParticipants.length) {
    const p = localParticipant;
    return (
      <Wrapper showParticipants={showParticipants}>
        <ParticipantView
          key={p.participantId}
          rows={1}
          width={windowDimensions.width}
          height={windowDimensions.height}
        >
          <Video participant={p} muted={p.participantId === localParticipant.participantId} />
          <ParticipantInfo>
            {p.isAudioEnabled || <ParticipantMutedIcon />}User ID: {p.user.userId}
          </ParticipantInfo>
        </ParticipantView>
      </Wrapper>
    );
  }

  const rows = Math.ceil(participants.length / 2);
  return (
    <Wrapper>
      <ParticipantsRow rows={1} showParticipants={showParticipants}>
        {participants.map(
          (p) =>
            p && (
              <ParticipantView
                showParticipants={showParticipants}
                rows={rows}
                width={windowDimensions.width}
                height={windowDimensions.height}
                key={p.participantId}
              >
                <Video participant={p} muted={p.participantId === localParticipant.participantId} />
                <ParticipantInfo>
                  {p.isAudioEnabled || <ParticipantMutedIcon />}
                  {p.user.nickname}
                </ParticipantInfo>
              </ParticipantView>
            )
        )}
      </ParticipantsRow>
    </Wrapper>
  );
};
export default MediaContent;
